export enum PassOrFail {
    PASS = 'PASS',
    FAIL = 'FAIL',
}